import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col, Toast } from '@themesberg/react-bootstrap';
import { useCookies } from 'react-cookie';
import { updateEmployeeInfo } from '../../../../../controller/api/employee';

const initialFormState = {
  name: '',
  phone: '',
  identify: '',
  password: ''
};

export default function EditEmployee(props) {
  const { show, onHide, employee, onSuccess } = props;
  const [cookies] = useCookies(['lottmekong']);
  const [form, setForm] = useState(initialFormState);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (employee) {
      setForm({
        name: employee.name || '',
        phone: employee.phone || '',
        identify: employee.identify || '',
        password: ''
      });
    } else {
      setForm(initialFormState);
    }
    setError('');
    setIsSubmitting(false);
  }, [employee, show]);

  const updateField = (field) => (evt) => {
    setForm(prev => ({
      ...prev,
      [field]: evt.target.value
    }));
  };

  const handleSubmit = async () => {
    if (!employee || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        id: employee.id,
        name: typeof form.name === 'string' ? form.name.trim() : '',
        phone: typeof form.phone === 'string' ? form.phone.trim() : '',
        identify: typeof form.identify === 'string' ? form.identify.trim() : ''
      };

      payload.name = payload.name.length > 0 ? payload.name : null;
      payload.phone = payload.phone.length > 0 ? payload.phone : null;
      payload.identify = payload.identify.length > 0 ? payload.identify : null;

      if (typeof form.password === 'string') {
        const trimmedPassword = form.password.trim();
        if (trimmedPassword.length > 0) {
          if (trimmedPassword.length < 6) {
            setError('Mật khẩu mới phải có tối thiểu 6 ký tự');
            setIsSubmitting(false);
            return;
          }
          payload.password = trimmedPassword;
        }
      }

      const resp = await updateEmployeeInfo(cookies.lottmekong, payload);

      if (resp && resp.status === 'success') {
        onSuccess && onSuccess();
      } else {
        setError(resp?.message || 'Có lỗi xảy ra');
      }
    } catch (err) {
      setError('Có lỗi xảy ra: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="edit-employee-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="edit-employee-modal">
          Chỉnh sửa nhân viên in vé
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Toast className="d-inline-block mb-3" onClose={() => setError('')} show={!!error} delay={3000} autohide bg='danger'>
          <Toast.Header>
            <strong className="me-auto">Lỗi</strong>
          </Toast.Header>
          <Toast.Body>{error || 'Không thể cập nhật thông tin nhân viên'}</Toast.Body>
        </Toast>
        <Form>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Username</Form.Label>
                <Form.Control type="text" value={employee?.username || ''} disabled readOnly />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Tên hiển thị</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nhập tên hiển thị"
                  value={form.name}
                  onChange={updateField('name')}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Số điện thoại (không bắt buộc)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nhập số điện thoại"
                  value={form.phone}
                  onChange={updateField('phone')}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>CMND/CCCD (không bắt buộc)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nhập số CMND/CCCD"
                  value={form.identify}
                  onChange={updateField('identify')}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Mật khẩu mới</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Để trống nếu không đổi"
                  value={form.password}
                  onChange={updateField('password')}
                />
                <Form.Text className="text-muted">
                  Để trống nếu không muốn thay đổi mật khẩu (tối thiểu 6 ký tự).
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Đóng
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting || !employee}>
          {isSubmitting ? 'Đang lưu...' : 'Lưu thay đổi'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
